"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.IdleStateListenerBase = void 0;
var events_1 = require("events");
var react_1 = __importDefault(require("react"));
var IdleStateListenerBase = /** @class */ (function (_super) {
    __extends(IdleStateListenerBase, _super);
    function IdleStateListenerBase() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isActive = true;
        _this.getIsActive = function () { return _this.isActive; };
        _this.useIsActive = function () {
            var _a = react_1["default"].useState(_this.isActive), v = _a[0], s = _a[1];
            react_1["default"].useEffect(function () {
                var cb = function () { return s(_this.isActive); };
                _this.on('active', cb);
                _this.on('idle', cb);
                return function () {
                    _this.off('active', cb);
                    _this.off('idle', cb);
                };
            }, []);
            return v;
        };
        return _this;
    }
    IdleStateListenerBase.prototype.onActive = function (cb) {
        var _this = this;
        var wrappedCb = function () {
            void cb();
        };
        this.on('active', wrappedCb);
        return {
            remove: function () {
                _this.off('active', wrappedCb);
            }
        };
    };
    return IdleStateListenerBase;
}(events_1.EventEmitter));
exports.IdleStateListenerBase = IdleStateListenerBase;
